import(/* webpackMode: "eager", webpackExports: ["CustomerForgotPasswordForm"] */ "/app/src/shared/components/forms/auth/customer/customer-forgot-password-form.component.tsx");
